import React from "react";

import styled, { withTheme } from "styled-components";
import { withRouter } from "react-router";
import GoogleAnalytics from "react-ga";
import { inject } from "mobx-react";

import Aside from "../components/Aside";
import Head from "../components/Head";
import Download from "../components/Download";
import Copyright from "../components/Copyright";
import timestamp from "../utils/timestamp";
import getLocale from "../utils/locale";

import locales from "../utils/locales";

import config from "../utils/config";

const StyledContainer = styled.div`
  position: relative;

  flex-direction: column;
  justify-content: center;

  display: flex;
  flex: 1;

  width: 1200px;
  height: 100%;
`;

const Wrapper = styled.main`
  margin: auto;

  display: flex;
  flex: 1;
  flex-direction: column;

  align-self: center;

  background-image: url(./assets/images/phone.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  padding: 8vh 5vh 11vh;

  width: 100%;
  max-width: calc((100vh / 16) * 9);

  @media (orientation: portrait) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    padding: 0;
    max-width: 100%;
    z-index: 9999;
  }
`;

const Game = styled.div`

    margin: auto;

    background-color: black;
    border: 5px solid black;
    width: 100%;
    height: 100%;

    position: relative;

    @media (orientation: portrait) {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        padding: 0;
        max-width: 100%;
        z-index: 9999;
    }

    iframe {
        ${props => `
            padding: ${(props.iframeHeight - 10) *
              0.08}px ${(props.iframeHeight - 20) *
          0.05}px ${(props.iframeHeight - 10) * 0.11}px;
            margin: -${(props.iframeHeight - 10) *
              0.08}px -${(props.iframeHeight - 20) *
          0.05}px -${(props.iframeHeight - 10) * 0.11}px;
        `}

        ${props => `
            width: ${((props.iframeHeight - 20) / 16) * 9}px;
        `}

        ${props => `
            height: ${props.iframeHeight - 10}px;
        `}

        @media (orientation: portrait) {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            padding: 0;
            max-width: 100%;
            z-index: 9999;

            padding: 0 !important;
            margin: 0 !important;

            ${props => `width: ${props.iframeWidth}px;`}
            ${props => `height: ${props.iframeHeight}px;`}
        }
    }

`;

const Pixel = styled.img.attrs({
  width: 1,
  height: 1
})``;

GoogleAnalytics.initialize(config.ga.code);

class Main extends React.Component {
  state = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    scale: 0.76
  };

  game = React.createRef();

  componentDidMount = () => {
    this.onHashChange();
    window.addEventListener("hashchange", this.onHashChange, false);
    window.addEventListener("message", this.onReceiveMessage, false);
    window.addEventListener("resize", this.onWindowResize);
  };
  componentWillUnmount = () => {
    window.removeEventListener("hashchange", this.onHashChange, false);
    window.removeEventListener("message", this.onReceiveMessage, false);
    window.removeEventListener("resize", this.onWindowResize);
  };
  render() {
    const { intl } = this.props;

    const { width, height } = this.state;

    const ROOT =
      process.env.NODE_ENV !== "production"
        ? "https://public.pushstart.com.br/demos/alaor-phone"
        : ".";

    return (
      <StyledContainer>
        <Head />
        <Aside />
        <Wrapper>
          <Game
            className="game-wrapper"
            iframeWidth={width}
            iframeHeight={height}
          >
            <iframe
              ref={this.game}
              scrolling="no"
              src={`${ROOT}/game/index.html?${timestamp}`}
              allowFullScreen={true}
              frameBorder={0}
            />
            <Copyright />
          </Game>
        </Wrapper>
        <Download />
        {intl.PIXEL_CONVERSION_FRFR ? (
          <Pixel src={intl.PIXEL_CONVERSION_FRFR} />
        ) : null}
        {intl.PIXEL_CONVERSION_PTBR ? (
          <Pixel src={intl.PIXEL_CONVERSION_PTBR} />
        ) : null}
        {intl.PIXEL_CONVERSION_ENUS ? (
          <Pixel src={intl.PIXEL_CONVERSION_ENUS} />
        ) : null}
        {intl.PIXEL_VISITORS_FRFR ? (
          <Pixel src={intl.PIXEL_VISITORS_FRFR} />
        ) : null}
      </StyledContainer>
    );
  }

  onReceiveMessage = ev => {
    if (!ev) return;

    let { data } = ev;

    if (!data) return;

    if (typeof data === "string") data = JSON.parse(data);

    if (!data.fnName) return;

    if (data.fnName === "requestLocale") this.onRequestLocale();

    if (data.fnName === "setLocale") this.onSetLocale(data.params[0]);
  };

  onRequestLocale = () => {
    let { locale } = this.props;
    let data = String(locale);

    this.onPostMessage("locale", data);
  };

  onSetLocale = toLocale => {
    const { history, locale } = this.props;
    let target = null;

    if (locale === toLocale) {
      this.onRequestLocale();
      return;
    }

    switch (toLocale) {
      case "pt-br":
        target = "pt-br";
        break;
      case "fr-fr":
        target = "fr-fr";
        break;
      case "sv-se":
        target = "sv-se";
        break;
      default:
        target = "en-us";
        break;
    }

    !!target && history.push(`/${toLocale}`);
  };

  onPostMessage = (fnName = "locale", value = "") => {
    const instance = this.game.current;

    let data = {
      type: "Rex_FrameMessage.Return",
      sender: "app",
      fnName,
      value
    };

    instance.contentWindow.postMessage(data, "*");
  };

  onHashChange = ev => {
    const locale = getLocale();
    const { setLocale } = this.props;
    let newUrl = window.location.hash;

    let page = null;

    newUrl = newUrl.replace("#/", "");

    if (!newUrl || (newUrl && !newUrl.length)) {
      window.location.hash = `#/${locale}`;
      return;
    }

    newUrl = (newUrl && newUrl.toLowerCase()) || "en-us";

    switch (newUrl) {
      case "pt-br":
        setLocale("pt-br");
        break;
      case "en-us":
        setLocale("en-us");
        break;
      case "fr-fr":
        setLocale("fr-fr");
        break;
      case "sv-se":
        setLocale("sv-se");
        break;
      case "p":
        break;
    }

    this.onRequestLocale();

    GoogleAnalytics.set({ page });
    GoogleAnalytics.pageview(page);
  };

  onWindowResize = () => {
    const width = document.documentElement.clientWidth;
    const height = document.documentElement.clientHeight;
    this.setState({ width, height });
  };
}

const mapper = (stores, props) => ({
  intl: locales[props.match.params.locale || stores.uiStore.getLocale.get()],
  locale: stores.uiStore.getLocale.get(),
  setLocale: locale => stores.uiStore.setLocale(locale)
});

export default withTheme(withRouter(inject(mapper)(Main)));



// WEBPACK FOOTER //
// ./src/screens/main.js